import { makeRoute } from '~/utils/route';

export default makeRoute({
	path:       '/importfile/executions',
	title:      'menu.importfile-exec',
	// @ts-ignore
	redirectTo:  () => {
		window.location.href = '/front5/importfile/executions';
	},
});
